import { render, staticRenderFns } from "./Movimentacoes.vue?vue&type=template&id=c0c92bee&scoped=true"
import script from "./Movimentacoes.vue?vue&type=script&lang=js"
export * from "./Movimentacoes.vue?vue&type=script&lang=js"
import style0 from "./Movimentacoes.vue?vue&type=style&index=0&id=c0c92bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c92bee",
  null
  
)

export default component.exports